import apiClient from '../../../lib/client';

export const voteAPI = {
  search: (q) => apiClient.get('/vote/search', { params: { q } }).then((r) => r.data),
  getStates: () => apiClient.get('/vote/states').then((r) => r.data),
  getState: (state, params = {}) => apiClient.get(`/vote/${state}`, { params }).then((r) => r.data),
  getLocation: (state, location) => apiClient.get(`/vote/${state}/${location}`).then((r) => r.data),
};
